import React from 'react'

interface UtensilsCrossedIconProps {
  className?: string;
}

const UtensilsCrossedIcon: React.FC<UtensilsCrossedIconProps> = ({ className }) => {
  return (

    <svg width="24" height="24" className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M14 7C14 7.28 13.94 7.55 13.84 7.79C15.766 8.18933 17.5084 9.20796 18.8013 10.6904C20.0941 12.1728 20.8663 14.0376 21 16H3C3.13369 14.0376 3.90589 12.1728 5.19872 10.6904C6.49156 9.20796 8.23398 8.18933 10.16 7.79C10.0291 7.48556 9.9759 7.15337 10.0052 6.82328C10.0345 6.49319 10.1453 6.17554 10.3278 5.8989C10.5102 5.62226 10.7585 5.39528 11.0504 5.23838C11.3423 5.08148 11.6686 4.99956 12 5C12.5304 5 13.0391 5.21072 13.4142 5.58579C13.7893 5.96086 14 6.46957 14 7ZM22 19V17H2V19H22Z" fill="#1E293B"/>
    </svg>
    
  )
}

export default UtensilsCrossedIcon

